import { Stack, Typography } from "@mui/material"
import Section from "./Section"

interface BlocProps {
  title: string
  desc?: string
  gain?: string
}

function Bloc({ title, desc, gain }: BlocProps) {
  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      justifyContent="space-around"
      sx={{
        flex: 1,
        p: 1.5,
        borderRadius: "12px",
        background: "rgba(255, 255, 255, 0.02)",
        border: "1px solid rgba(255, 255, 255, 0.03)",
      }}
    >
      <Stack alignItems="center" width="100%" spacing={1}>
        <Typography variant="h6" fontWeight={700}>
          {title}
        </Typography>
        <Stack direction={"row"}>
          {gain && (
            <Typography color="rgb(79, 150, 13)" fontSize={28} fontWeight={700}>
              {gain}
            </Typography>
          )}
        </Stack>
        {desc && (
          <Typography color="rgb(79, 150, 13)" fontSize={16} fontWeight={700}>
            {desc}
          </Typography>
        )}
      </Stack>
    </Stack>
  )
}

export interface ResultsProps {
  phone: boolean
}

export default function Results({ phone }: ResultsProps) {
  return (
    <Section>
      <Stack sx={{ width: "100%" }} alignItems="start" spacing={2}>
        <Typography fontWeight="bold" fontSize={34} sx={{ p: 1 }}>
          Des gains mesurables, un déploiement sans risque
        </Typography>
        <Stack width="100%" spacing={2}>
          <Stack direction={phone ? "column" : "row"} width="100%" spacing={2}>
            <Bloc title="Distance parcourue" gain="-26.4%" />
            <Bloc title="Productivité" gain="+12.7%" />
            <Bloc title="ROI" desc="" gain="Immédiat" />
          </Stack>
          <Stack direction={phone ? "column" : "row"} width="100%" spacing={2}>
            <Bloc title="WMS" desc="Sans changer de WMS" />
            <Bloc
              title="Méthodes de travail"
              desc="Sans changer de méthodes de travail"
            />
            <Bloc title="Abonnement" desc="Sans engagement" />
          </Stack>
        </Stack>
      </Stack>
    </Section>
  )
}
